import { render } from "./Testing.vue?vue&type=template&id=f5f89b12&scoped=true&bindings={}"
import script from "./Testing.vue?vue&type=script&lang=ts"
export * from "./Testing.vue?vue&type=script&lang=ts"

import "./Testing.vue?vue&type=style&index=0&id=f5f89b12&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f5f89b12"

export default script